module.exports = __webpack_public_path__ + "7f43a0a8d17a65e8cf4e57f412d877e2.MP3";